var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6992 0H9.69922C4.73572 0 0.699219 4.0365 0.699219 9V28.5C0.699219 28.8978 0.857254 29.2794 1.13856 29.5607C1.41986 29.842 1.80139 30 2.19922 30H21.6992C26.6627 30 30.6992 25.9635 30.6992 21V9C30.6992 4.0365 26.6627 0 21.6992 0ZM27.6992 21C27.6992 24.309 25.0082 27 21.6992 27H3.69922V9C3.69922 5.691 6.39022 3 9.69922 3H21.6992C25.0082 3 27.6992 5.691 27.6992 9V21Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 19.3182V22.2008H11.38L19.3457 14.238L16.4672 11.3568L8.5 19.3182ZM20.7029 12.8796L17.8243 9.99553L20.0186 7.80078L22.9 10.6834L20.7029 12.8796Z",
    fill: "#FF7A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageEdit);
export default __webpack_public_path__ + "static/media/manage_edit.d9baba11c1ac7865449e80fd5c5c0a18.svg";
export { ForwardRef as ReactComponent };